import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import ScrollView from "devextreme-react/scroll-view";
import data from "../../assets/apiRoutes.json";
import TextBox from 'devextreme-react/text-box';  
import { Popup, ToolbarItem } from "devextreme-react/popup";
import {
  GetMinutesFromDate,
  GetHoursFromDate,
  GetDatePartOnly,
  GetTimePartOnly,
  GetDateTimeStandardFormat
} from "../../common/Utils";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";


const TransactionSchedulingPopUp = (props) => {
  const dataBase =
    props.ReceiptReducer.wmTransactionDatabase !== ""
      ? props.ReceiptReducer.wmTransactionDatabase
      : "";
  const [popupState, setPopUpState] = useState(props.visibility);
  const [dataItmGrid, setDataItmGrid] = useState([]);
  const [transactionSchedulingObj, setTransactionSchedulingObj] = useState({
    dbName: dataBase,
    Rowid: props.transRowid,
  });
  const [transactionObj, setTransactionObj] = useState({
    transactionnumber: "",
    actualreceivedshippeddatetime: "",
    shipper: "",
    shipperbolnumber: "",
  });
  const [transactionSchedulingStagingObj, setTransactionSchedulingStagingObj] =
    useState([
      {
        stagingWarehouse:"",
        stagingArea:"",
        plannedReceivedShippedDatetime:"",
        stagingStartDate:"",
        stagingEndDate:"",
      },
    ]);
  const [
    transactionSchedulingDockYardObj,
    setTransactionSchedulingDockYardObj,
  ] = useState([
    {
      transportationWarehouse:'',
      transportationLocation:'',
      transportationArrivalDate:'',
      transportationDockStartDate:'',
      transportationDockEndDate:'',
      transportationLeaveDate:'',
    },
  ]);

  const [
    transactionSchedulingAssignmentsObj,
    setTransactionSchedulingAssignmentsObj,
  ] = useState([
    {
      title: "",
      PlanDate: "",
      Time: "",
      Hours: "",
      Minutes: "",
    },
  ]);

  var accessToken = props.oidc.user.access_token;
  const columns = ["Transaction #", "Recv/ShipDT", "Shipper", "Shipper#"];

  const hideInfo = () => {
    setPopUpState(false);
    props.parentCallback(false);
  };

  useEffect(() => {
    loadTransactionScheduling();
    loadInventoryTransactionData();
  }, []);
  const loadTransactionScheduling = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionSchedulings}`,
        transactionSchedulingObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setTransactionSchedulingStagingObj(res.data);
        setTransactionSchedulingDockYardObj(res.data);
        setTransactionSchedulingAssignmentsObj(
          loadDataForAssignmentsGrid(res.data)
        );
      });
  };
  const loadInventoryTransactionData = () => {
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.GetTransactionData}`,
        transactionSchedulingObj,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        var transData = res.data;
        setTransactionObj(transData);
        setDataItmGrid([
          {
            "Transaction #": transData.transactionnumber,
            "Recv/ShipDT": transData.actualreceivedshippeddatetime ? GetDateTimeStandardFormat(transData.actualreceivedshippeddatetime) : "",
            Shipper: transData.shipper,
            "Shipper#": transData.shipperbolnumber,
          },
        ]);
      });
  };

  function loadDataForStagingGrid(data) {
    return [
      {
        title: "Warehouse/Area",
        Col1: data?.stagingWarehouse ? data?.stagingWarehouse : "",
        Col2: data?.stagingArea ? data?.stagingArea : "",
      },
      {
        title: "Planned",
        Col1: data?.plannedReceivedShippedDatetime
          ? GetDatePartOnly(data?.plannedReceivedShippedDatetime)
          : "",
        Col2: data?.plannedReceivedShippedDatetime
          ? GetTimePartOnly(data?.plannedReceivedShippedDatetime)
          : "",
      },
      {
        title: "Start",
        Col1: data?.stagingStartDate
          ? GetDatePartOnly(data?.stagingStartDate)
          : "",
        Col2: data?.stagingStartDate
          ? GetTimePartOnly(data?.stagingStartDate)
          : "",
      },
      {
        title: "Finish",
        Col1: data?.stagingEndDate ? GetDatePartOnly(data?.stagingEndDate) : "",
        Col2: data?.stagingEndDate ? GetTimePartOnly(data?.stagingEndDate) : "",
      },
    ];
  }
  function loadDataForDockYardGrid(data) {
    return [
      {
        title: "Warehouse/Location",
        Col1: data?.transportationWarehouse
          ? data?.transportationWarehouse
          : "",
        Col2: data?.transportationLocation ? data?.transportationLocation : "",
      },
      {
        title: "Yard - Arrive",
        Col1: data?.transportationArrivalDate
          ? GetDatePartOnly(data?.transportationArrivalDate)
          : "",
        Col2: data?.transportationArrivalDate
          ? GetTimePartOnly(data?.transportationArrivalDate)
          : "",
      },
      {
        title: "Dock - Start",
        Col1: data?.transportationDockStartDate
          ? GetDatePartOnly(data?.transportationDockStartDate)
          : "",
        Col2: data?.transportationDockStartDate
          ? GetTimePartOnly(data?.transportationDockStartDate)
          : "",
      },
      {
        title: "Dock - Finish",
        Col1: data?.transportationDockEndDate
          ? GetDatePartOnly(data?.transportationDockEndDate)
          : "",
        Col2: data?.transportationDockEndDate
          ? GetTimePartOnly(data?.transportationDockEndDate)
          : "",
      },
      {
        title: "Yard Leave",
        Col1: data?.transportationLeaveDate
          ? GetDatePartOnly(data?.transportationLeaveDate)
          : "",
        Col2: data?.transportationLeaveDate
          ? GetTimePartOnly(data?.transportationLeaveDate)
          : "",
      },
    ];
  }
  function loadDataForAssignmentsGrid(data) {
    return [
      {
        title: "Unload By",
        Worker: data?.unloadPickby ? data?.unloadPickby : "",
        PlanDate: data?.unloadPickbyPlanDate
          ? GetDatePartOnly(data?.unloadPickbyPlanDate)
          : "",
        Time: data?.unloadPickbyPlanDate
          ? GetTimePartOnly(data?.unloadPickbyPlanDate)
          : "",
        Hours: data?.unLoadPickByHours
          ? GetHoursFromDate(data?.unLoadPickByHours)
          : "",
        Minutes: data?.unLoadPickByHours
          ? GetMinutesFromDate(data?.unLoadPickByHours)
          : "",
      },
      {
        title: "Check By",
        Worker: data?.checkBy ? data?.checkBy : "",
        PlanDate: data?.checkByPlanDate
          ? GetDatePartOnly(data?.checkByPlanDate)
          : "",
        Time: data?.checkByPlanDate
          ? GetTimePartOnly(data?.checkByPlanDate)
          : "",
        Hours: data?.checkByHours ? GetHoursFromDate(data?.checkByHours) : "",
        Minutes: data?.checkByHours
          ? GetMinutesFromDate(data?.checkByHours)
          : "",
      },
      {
        title: "Put Away By",
        Worker: data?.putawayBy ? data?.putawayBy : "",
        PlanDate: data?.putAwayByPlanDate
          ? GetDatePartOnly(data?.putAwayByPlanDate)
          : "",
        Time: data?.putAwayByPlanDate
          ? GetTimePartOnly(data?.putAwayByPlanDate)
          : "",
        Hours: data?.putAwayByHours
          ? GetHoursFromDate(data?.putAwayByHours)
          : "",
        Minutes: data?.putAwayByHours
          ? GetMinutesFromDate(data?.putAwayByHours)
          : "",
      },
      {
        title: "Load By",
        Worker: data?.loadBy ? data?.loadBy : "",
        PlanDate: data?.loadByPlanDate
          ? GetDatePartOnly(data?.loadByPlanDate)
          : "",
        Time: data?.loadByPlanDate ? GetTimePartOnly(data?.loadByPlanDate) : "",
        Hours: data?.loadByHours ? GetHoursFromDate(data?.loadByHours) : "",
        Minutes: data?.loadByHours ? GetMinutesFromDate(data?.loadByHours) : "",
      },
      {
        title: "Pick By",
        Worker: data?.pickBy ? data?.pickBy : "",
        PlanDate: data?.pickByPlanDate
          ? GetDatePartOnly(data?.pickByPlanDate)
          : "",
        Time: data?.pickByPlanDate ? GetTimePartOnly(data?.pickByPlanDate) : "",
        Hours: data?.pickByHours ? GetHoursFromDate(data?.pickByHours) : "",
        Minutes: data?.pickByHours ? GetMinutesFromDate(data?.pickByHours) : "",
      },
    ];
  }

  return (
    <Popup
      visible={popupState}
      onHiding={hideInfo}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Transaction Scheduling"
      //container=".inventory-container"
      container="#root"
      width="80vw"
      height="97vh"
      fullScreen={false}
    >
      <div className="popup-content">

          {/* transaction Grid */}
          <div className="row">
            <div className="col-md-12">
              <fieldset className="h-100" >
                <legend className="h6">Transaction</legend>
          <div className="row">
          <div className="col-md-3" >
            <TextBox
              label="Transaction #"
              name="transactionnumber"
              value={transactionObj.transactionnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Recv/ShipDT"
              name="Recv/ShipDT"
              value={transactionObj.actualreceivedshippeddatetime ? GetDateTimeStandardFormat(transactionObj.actualreceivedshippeddatetime) : ""}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Shipper"
              name="Shipper"
              value={transactionObj.shipper}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          <div className="col-md-3">
            <TextBox
              label="Shipper#"
              name="ShipperNumber"
              value={transactionObj.shipperbolnumber}
              stylingMode='outlined'
              labelMode="static"
              readOnly={true}
            />
          </div>
          </div>
          </fieldset>
          </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <fieldset className="h-100 topMargin" >
                <legend className="h6">Staging</legend>
                <div className="row">
                  <div className="col-md-6">
                    <TextBox
                      label="Warehouse"
                      name="Warehouse"
                      value={transactionSchedulingStagingObj.stagingWarehouse}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextBox
                      label="Area"
                      name="Area"
                      value={transactionSchedulingStagingObj.stagingArea}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Planned Date"
                      name="PlanDate"
                      value={transactionSchedulingStagingObj?.plannedReceivedShippedDatetime ? GetDatePartOnly(transactionSchedulingStagingObj.plannedReceivedShippedDatetime) : ''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Planned Time"
                      name="PlanTime"
                      value={transactionSchedulingStagingObj?.plannedReceivedShippedDatetime ? GetTimePartOnly(transactionSchedulingStagingObj.plannedReceivedShippedDatetime):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Start Date"
                      name="StartDate"
                      value={transactionSchedulingStagingObj.stagingStartDate ? GetDatePartOnly(transactionSchedulingStagingObj.stagingStartDate) : ''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Start Time"
                      name="StartTime"
                      value={transactionSchedulingStagingObj.stagingStartDate ? GetTimePartOnly(transactionSchedulingStagingObj.stagingStartDate) : ''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Finish Date"
                      name="FinishDate"
                      value={transactionSchedulingStagingObj.stagingEndDate ? GetDatePartOnly(transactionSchedulingStagingObj.stagingEndDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="End Time"
                      name="EndTime"
                      value={transactionSchedulingStagingObj.stagingEndDate ? GetTimePartOnly(transactionSchedulingStagingObj.stagingEndDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-md-6">
              <fieldset className="h-100 topMargin" >
                <legend className="h6">Yard Information</legend>
                <div className="row">
                  <div className="col-md-6">
                    <TextBox
                      label="Warehouse"
                      name="WArehouse"
                      value={transactionSchedulingDockYardObj.transportationWarehouse}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextBox
                      label="Location"
                      name="Location"
                      value={transactionSchedulingDockYardObj.transportationLocation}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  </div>
                  <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Yard Arrival Date"
                      name="ArrivalDate"
                      value={transactionSchedulingDockYardObj.transportationArrivalDate?GetDatePartOnly(transactionSchedulingDockYardObj.transportationArrivalDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Yard Arrival Time"
                      name="ArrivalTime"
                      value={transactionSchedulingDockYardObj.transportationArrivalDate?GetTimePartOnly(transactionSchedulingDockYardObj.transportationArrivalDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Dock Start Date"
                      name="DockStartDate"
                      value={transactionSchedulingDockYardObj.transportationDockStartDate?GetDatePartOnly(transactionSchedulingDockYardObj.transportationDockStartDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Dock Start Time"
                      name="DockStartTime"
                      value={transactionSchedulingDockYardObj.transportationDockStartDate?GetTimePartOnly(transactionSchedulingDockYardObj.transportationDockStartDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Dock Finish Date"
                      name="DockEndDate"
                      value={transactionSchedulingDockYardObj.transportationDockEndDate?GetDatePartOnly(transactionSchedulingDockYardObj.transportationDockEndDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Dock Finish Time"
                      name="DockFinishTime"
                      value={transactionSchedulingDockYardObj.transportationDockEndDate?GetTimePartOnly(transactionSchedulingDockYardObj.transportationDockEndDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Yard Leave Date"
                      name="YardLeaveDate"
                      value={transactionSchedulingDockYardObj.transportationLeaveDate?GetDatePartOnly(transactionSchedulingDockYardObj.transportationLeaveDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-md-6 topMargin">
                    <TextBox
                      label="Yard Leave Time"
                      name="DockLeaveTime"
                      value={transactionSchedulingDockYardObj.transportationLeaveDate?GetTimePartOnly(transactionSchedulingDockYardObj.transportationLeaveDate):''}
                      stylingMode='outlined'
                      labelMode="static"
                      readOnly={true}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          {/* Assignments Grid */}
          <div className="row">
            <div className="col-md-12">
            <fieldset className="h-100 topMargin">
            <legend className="h6">Assignments</legend>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                noDataText={
                  transactionSchedulingAssignmentsObj.length > 0 ? "" : "No Data"
                }
                dataSource={transactionSchedulingAssignmentsObj}
                showBorders={true}
                height={250}
                className="customDataTableDesign"
                hoverStateEnabled={true}
                allowColumnResizing={true}
                allowColumnReordering={false}
                rowAlternationEnabled={false}
                showRowLines={true}
                showColumnLines={false}
              >
                <Export
                  enabled={false}
                  allowExportSelectedData={false}
                  text="Export"
                />
                <ColumnHeaderFilter />
                <LoadPanel enabled={true} />
                <Paging defaultPageSize={10} />
                <Sorting visible={false} />
                <Pager
                  visible={true}
                  showPageSizeSelector={true}
                  allowedPageSizes={[5, 10, 20, "all"]}
                  showNavigationButtons={true}
                />
                <Column
                  allowSorting={false}
                  cssClass={"cell-highlighted"}
                  dataField="title"
                  caption="Type"
                ></Column>
                <Column
                  allowSorting={false}
                  dataField="Worker"
                  caption="Worker"
                ></Column>
                <Column
                  allowSorting={false}
                  dataField="PlanDate"
                  caption="Plan Date"
                ></Column>
                <Column
                  allowSorting={false}
                  dataField="Time"
                  caption="Time"
                ></Column>
                <Column
                  allowSorting={false}
                  dataField="Hours"
                  caption="Hours"
                ></Column>
                <Column
                  allowSorting={false}
                  dataField="Minutes"
                  caption="Minutes"
                ></Column>
              </DataGrid>
              </fieldset>
            </div>
          </div>
      </div>

    </Popup>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionSchedulingPopUp);
